// extracted by mini-css-extract-plugin
export default {"innerWrapper":"xz-z","tooltipWrapper":"yz-z","icon":"zz-z","tooltip":"Az-z","content":"Bz-z"};